function initializeCountdowns() {
    const timers = document.querySelectorAll('.global-countdown-container');
    timers.forEach(timer => {
      const deadline = new Date(timer.getAttribute('data-deadline')).getTime();
      
      const weeksEl = timer.querySelector('.global-weeks');
      const daysEl = timer.querySelector('.global-days');
      const hoursEl = timer.querySelector('.global-hours');
      const minutesEl = timer.querySelector('.global-minutes');
      const secondsEl = timer.querySelector('.global-seconds');
      const updateTimer = () => {
        const now = new Date().getTime();
        const distance = deadline - now;
        if (distance < 0) {
          const timerDisplay = timer.querySelector(".global-timer-display");
          if (timerDisplay) timerDisplay.style.display = "none";
          clearInterval(intervalId);
          return;
        }
        
        const weeks = Math.floor(distance / (1000 * 60 * 60 * 24 * 7));
        const days = Math.floor((distance % (1000 * 60 * 60 * 24 * 7)) / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
        if(weeksEl) weeksEl.innerText = weeks.toString().padStart(2, '0');
        daysEl.innerText = days.toString().padStart(2, '0');
        hoursEl.innerText = hours.toString().padStart(2, '0');
        minutesEl.innerText = minutes.toString().padStart(2, '0');
        if(secondsEl) secondsEl.innerText = seconds.toString().padStart(2, '0');
      };
      // Run every minute
      updateTimer();
      setInterval(updateTimer, 60000);
    });
   }
   document.addEventListener('DOMContentLoaded', initializeCountdowns);


// WEBPACK FOOTER //
// ./components/global-countdown-timer/_global-countdown-timer.js